import { isFeatureEnabled } from 'owa-feature-flags';
import isGroupSelected from './isGroupSelected';

export default function isMessageActionFromGroup(): boolean {
    return isFeatureEnabled('grp-loadFolders') && isGroupSelected();
}
